import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { SUN_PAYMENT_LABEL, SUN_PAYMENT_STATUS } from "../status"

// sun_payment_status is set ONLY by the SUN listener (brief §10). UI is read-only.
const SunPaymentBadge = ({ status }) => {
  if (!status) return null
  const color = status === SUN_PAYMENT_STATUS.PAID ? "success" : "warning"
  return (
    <MDBox
      display="inline-block"
      px={1.5}
      py={0.5}
      borderRadius="md"
      bgColor={color}
      color="white"
    >
      <MDTypography variant="caption" color="white" fontWeight="medium">
        {SUN_PAYMENT_LABEL[status] || status}
      </MDTypography>
    </MDBox>
  )
}

export default SunPaymentBadge
